export default "__VITE_ASSET__$CfrRj0O__"